import React from "react";
import "./tiles.css";
import { css } from "@emotion/core"
import {Link} from "gatsby";
import "../../styles/PostsPage.css"

const Post = ({ post }) => {
    const { slug } = post.fields
    let background_image;
    switch (post.frontmatter.category) {
        case "Recipes":
            background_image = "/images/posts/Recipes.png";
            break;
        case "Thoughts":
            background_image = "/images/posts/Thoughts.png";
            break;
        case "Culture":
            background_image = "/images/posts/Culture.png";
            break;
        case "Programming":
            background_image = "/images/posts/Programming.png";
            break;
        case "Science":
            background_image = "/images/posts/Science.png";
            break;
        case "Other":
            background_image = "/images/posts/Other.png";
            break;
    }
    return (
        <div class="entry-container">
            <div class="left-container-part">
                <div class="post-image"  style ={ { backgroundImage: "url("+background_image+")" } }></div>
            </div>
            <div class="right-container-part">
                <div class="upper-right-container-part">
                    <div class="date">{post.frontmatter.date}</div>
                    {post.frontmatter.tags.split(",").map(tag =>
                        <div className="bubble">{tag}</div>
                    )}
                </div>
                <div class={"lower-right-container-part"}>
                    <div class="post" key={post.id}>
                        <h2>
                            <Link to={slug}>{post.frontmatter.title}</Link>
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Post;